export enum Platform {
  BACK_OFFICE = 'back-office',
  FRONT_DYNAMIC = 'front-dynamic',
  LEARNIZ = 'learniz',
  SCORM = 'scorm',
  GAME = 'game',
  SMART_SEQUENCE = 'smart-sequence',
}
